import { attachSelectSearch } from '@shared/directives';
import { RequestCanceller } from '@shared/utils/http/request-canceller';
import isObject from 'lodash-es/isObject';
import isString from 'lodash-es/isString';
/**
 * serviceContractTypeSelectDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */
import { ServiceContractTypePresenter } from '../service-contract-type-presenter';

serviceContractTypeSelectDirective.$inject = ['$serviceContractTypeFetcher', '$errorHandler', '$q', '$util'];

export function serviceContractTypeSelectDirective($serviceContractTypeFetcher, $errorHandler, $q, $util) {
    return {
        //language=HTML
        template: `
            <md-input-container>
                <label>{{ label }}</label>

                <md-select name="{{ name }}"
                           md-on-close="onClose()"
                           ng-model="value"
                           ng-model-options="{ trackBy: '$value.id' }"
                           ng-change="_onChange()"
                           ng-disabled="disabled"
                           ng-required="required"
                           placeholder="{{ placeholder }}">

                    <md-select-header class="app-form-select-search-container"
                                      ng-if="serviceContractTypes.length > 5">
                        <input type="search"
                               class="md-text"
                               ng-model="ui.searchTerm"
                               placeholder="Search for a contract...">
                    </md-select-header>

                    <md-option class="app-form-select-option"
                               ng-repeat="serviceContractType in serviceContractTypes | filter:search track by serviceContractType.id"
                               ng-value="serviceContractType">

                        <div md-highlight-text="ui.searchTerm"
                             md-highlight-flags="gi">
                            {{ serviceContractType.description }}
                        </div>

                        <small class="app-form-select-option-meta">
                            {{ serviceContractType.$presenter.teamNames }}
                        </small>
                    </md-option>
                </md-select>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>

                <small class="hint" ng-if="hint">
                    {{ hint }}
                </small>
            </md-input-container>

            <md-button class="md-icon-button app-form-field-clear"
                       ng-if="isClearable"
                       ng-disabled="value === undefined"
                       ng-click="clear()">
                <md-icon>clear</md-icon>
            </md-button>
        `,
        scope: {
            isClearable: '=?clearable',
            onChange: '&?change',
            data: '=?data',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            hint: '@hint',
            label: '@label',
            name: '@name',
            noFloat: '=?noFloat',
            params: '=?params',
            required: '=?required',
            teams: '=?teams',
            placeholder: '@?placeholder',
            value: '=value'
        },
        link: function(scope, element, attrs) {
            const requestCanceller = new RequestCanceller();

            element.addClass('app-form-field');
            element.addClass('app-form-select');
            element.addClass('app-form-select-large');

            scope.serviceContractTypes = [];

            scope._onChange = _onChange;
            scope.clear = clear;
            scope.search = search;

            scope.ui = {
                searchTerm: ''
            };

            // Main

            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            if (angular.isDefined(scope.data)) {
                _setServiceContractTypes(scope.data);
            } else {
                _fetchServiceContractTypes();
            }

            scope.$watch('params', params => params && _fetchServiceContractTypes(), true);
            scope.$watchCollection('teams', teams => teams && _fetchServiceContractTypes());
            scope.$watch('data', data => _setServiceContractTypes(data));

            attachSelectSearch(element, scope);

            // Functions

            function clear() {
                scope.value = undefined;

                _onChange();
            }

            /**
             * @return {Promise}
             * @private
             */
            function _fetchServiceContractTypes() {
                requestCanceller.cancel();

                const params = {
                    include: ['teams:fields(simple)'],
                    order_by: 'description',
                    direction: 'asc',
                    timeout: requestCanceller.start(),
                    ...(scope.params || {}),
                };

                if (params.hasOwnProperty('team') && !params.team) {
                    params.team = '';
                }

                if (Array.isArray(scope.teams)) {
                    const teams = scope.teams
                        .map(team => {
                            if (isString(team)) {
                                return team;
                            } else if (isObject(team)) {
                                return team.id;
                            }
                        })
                        .filter(Boolean);

                    params.team = teams.join(',');
                }

                return $serviceContractTypeFetcher
                    .all(params)
                    .then($util.nextTick(response => _setServiceContractTypes(response.data)))
                    .catch(error => $errorHandler.handle(error));
            }

            function _onChange() {
                if (angular.isFunction(scope.onChange)) {
                    scope.onChange({
                        value: scope.value,
                    });
                }
            }

            function search(serviceContractType) {
                if (!scope.ui.searchTerm) {
                    return true;
                }

                const queryParts = scope.ui.searchTerm.toLowerCase().split(' ');

                for (const queryPart of queryParts) {
                    if (serviceContractType.description.toLowerCase().indexOf(queryPart) !== -1) {
                        return true;
                    }
                }

                return false;
            }

            function _setServiceContractTypes(serviceContractTypes = []) {
                const currentValue = scope.value;

                if (currentValue && !serviceContractTypes.some(type => type.id === currentValue.id)) {
                    serviceContractTypes = [currentValue, ...serviceContractTypes];
                }

                scope.serviceContractTypes = ServiceContractTypePresenter.attach(serviceContractTypes);
            }
        },
    };
}
